import BCHistory from '../../shared/components/Bc-History/Bc-History';
const History = () => {
    return(
            <>
            <BCHistory />
            </>
    )
};

export default History